import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  publicNetworks: [],
  selectedPublicNetwork: {},
  publicNetworkOrders: [],
  isLoading: false,
  error: null,
};

const publicNetworksSlice = createSlice({
  name: 'publicNetworks',
  initialState,
  reducers: {
    start: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    setReducerError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    setPublicNetworks: (state, action) => {
      state.publicNetworks = action.payload;
      state.isLoading = false;
    },
    setSelectedPublicNetwork: (state, action) => {
      state.selectedPublicNetwork = action.payload;
      state.isLoading = false;
    },
    setUpdatedPublicNetwork: (state, action) => {
      state.selectedPublicNetwork = action.payload;
      state.isLoading = false;
    },
    setDeletedPublicNetwork: (state, action) => {
      state.publicNetworks = state.publicNetworks.filter((network) => network.id !== action.payload);
      state.isLoading = false;
    },
    setRetiredPublicNetwork: (state, action) => {
      state.publicNetworks = state.publicNetworks.map((network) =>
        network.id === action.payload ? { ...network, retired: true } : network,
      );
      state.isLoading = false;
    },
    setPublicNetworkOrders: (state, action) => {
      state.publicNetworkOrders = action.payload;
      state.isLoading = false;
    },
    addPublicNetworkOrder: (state, action) => {
      state.publicNetworkOrders.push(action.payload);
      state.isLoading = false;
    },
    setSyncPublicNetworkOrders: (state, action) => {
      state.publicNetworkOrders = action.payload;
      state.isLoading = false;
    },
    resetPublicNetworks: () => initialState,
  },
});

export const {
  start,
  setReducerError,
  setPublicNetworks,
  setSelectedPublicNetwork,
  setUpdatedPublicNetwork,
  setDeletedPublicNetwork,
  setRetiredPublicNetwork,
  setPublicNetworkOrders,
  addPublicNetworkOrder,
  setSyncPublicNetworkOrders,
  resetPublicNetworks,
} = publicNetworksSlice.actions;

export default publicNetworksSlice.reducer;
